"use strict";
import { jsx } from "react/jsx-runtime";
import DrawingUtils from "../../util/drawing_utils";
import Circle from "./circle";
import CONSTANTS from "./constants";
import theme from "./theme";
const { DRAG_POINT_RADIUS } = CONSTANTS;
const { distance } = DrawingUtils;
const DragPoint = ({ hovered, position }) => {
  return /* @__PURE__ */ jsx(
    Circle,
    {
      position: {
        center: position,
        radius: DRAG_POINT_RADIUS
      },
      lineWidth: hovered ? 2 : 0,
      lineColor: theme.COLORS.base,
      fillColor: theme.COLORS.transBase
    }
  );
};
DragPoint.isPointIn = (point) => (connectorPos) => {
  return distance(point, connectorPos).length() < DRAG_POINT_RADIUS;
};
export default DragPoint;
